import { render } from "./WCRotateDeviceOverlay.vue?vue&type=template&id=10d11812&scoped=true"
const script = {}

import "./WCRotateDeviceOverlay.vue?vue&type=style&index=0&id=10d11812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d11812"]])

export default __exports__